"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sourceSubMenu = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
const sourceSubMenu = exports.sourceSubMenu = [{
  path: '/sources/list',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/master/sources/list.vue'))),
  name: 'Sources',
  meta: {
    title: 'master.source.title',
    noCache: true,
    icon: 'banner'
  }
}, {
  path: '/sources/add',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/master/sources/manage.vue'))),
  name: 'Add Source',
  props: {
    isEdit: false
  },
  meta: {
    title: 'master.source.manage',
    noCache: true,
    activeMenu: '/sources/list',
    hidden: true
  }
}, {
  path: '/sources/edit/:id(\\d+)',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/master/sources/manage.vue'))),
  name: 'Edit Source',
  props: {
    isEdit: true
  },
  meta: {
    title: 'master.source.manage',
    noCache: true,
    activeMenu: '/sources/list',
    hidden: true
  }
}];